import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { FileTransfersTable } from '../../utils/filetransfers-table';
import { open_upgrade_dialog } from '../../device-settings/upgrade-dialog/redux/action';
import { any2unix, pad0, unixToDate } from 'utils';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { matchesRegex, minMaxStr } from 'webui/Z3KConfigParser/validation/basic';
import { all, validate_by_specification, } from 'webui/Z3KConfigParser/validation/collections';
import { StrictDateInput } from 'console/shared/components/fields';
import { ControlWithoutLabel } from 'console/shared/components/fields/control/without-label';
import { selectDevice } from 'entities/device/lib';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { PasswordInput } from 'console/shared/components/fields/text/password';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { ServiceButtons } from 'console/device-settings/z3k/components/service/components/service-buttons';
export const parse_service_date_to_unix = (date) => {
    if (date) {
        const { year, month, day } = date;
        return any2unix(new Date(year, month - 1, day));
    }
    return 0;
};
export const parse_service_date_to_object = (date) => {
    const unix_date = new Date(date * 1e3);
    return {
        year: unix_date.getFullYear(),
        month: unix_date.getMonth() + 1,
        day: unix_date.getDate(),
    };
};
const ServicePageImpl = memo(function ServicePageImpl(props) {
    const { tab_key, state, volatile_data, validation, filetransfers, online, onChangeState, onOpenUpgradeDialog, } = props;
    const service_mode = useMemo(() => volatile_data.service_mode, [volatile_data]);
    return (_jsxs(SettingCard, { title: "\u0421\u0435\u0440\u0432\u0438\u0441", children: [_jsx(Typography, { children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0441\u0435\u0440\u0432\u0438\u0441\u0430" }), service_mode ? (_jsx(ControlWithoutLabel, { validation_result: unpack_validation(validation, 'phone'), validation_warnings_result: null, value: state.phone, onChange: (value) => onChangeState(tab_key, {
                    phone: value,
                }), field: (input_props) => (_jsx(TextInputWrapper, { placeholder: "+7", ...input_props })) })) : (_jsx(Typography, { children: state.phone })), _jsx(Typography, { children: "\u0414\u0430\u0442\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F" }), service_mode ? (_jsx(ControlWithoutLabel, { validation_result: null, validation_warnings_result: null, value: state.date, onChange: (value) => onChangeState(tab_key, {
                    date: value,
                }), field: StrictDateInput })) : (_jsx(Typography, { children: unixToDate(state.date) })), volatile_data.service_mode && (_jsxs("form", { autoComplete: "off", children: [_jsx(Typography, { children: "\u0421\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C" }), _jsx(ControlWithoutLabel, { validation_result: unpack_validation(validation, 'usbpassword'), validation_warnings_result: null, value: state.usbpassword, onChange: (value) => onChangeState(tab_key, {
                            usbpassword: value,
                        }), field: PasswordInput })] })), volatile_data.service_mode && (_jsxs(_Fragment, { children: [_jsx(Typography, { children: "\u0412\u0435\u0440\u0441\u0438\u044F \u043F\u0440\u043E\u0448\u0438\u0432\u043A\u0438" }), _jsxs(Box, { display: "flex", alignItems: "center", gap: 2, children: [_jsx(Typography, { display: "inline", children: state.firmware_version }), _jsx(Button, { variant: "outlined", color: "info", fullWidth: true, onClick: onOpenUpgradeDialog, children: "\u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C" })] })] })), filetransfers.some((ft) => !ft.done) && (_jsx(SettingFullRow, { children: _jsx(FileTransfersTable, { device_id: state.device_id, filetransfers: filetransfers, online: online }) })), service_mode && (_jsx(SettingCard, { title: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435", children: _jsx(ServiceButtons, { device_id: state.device_id, online: !!online }) }))] }));
});
const empty_filetransfers = [];
const ServicePage = connect((state, own_props) => {
    const device = selectDevice(state, own_props.state.device_id);
    return {
        filetransfers: device?.filetransfers ?? empty_filetransfers,
        online: device?.online,
    };
}, {
    onOpenUpgradeDialog: open_upgrade_dialog,
})(ServicePageImpl);
export const service_tab = {
    key: 'service',
    title: 'Сервис',
    element(props) {
        return _jsx(ServicePage, { ...props });
    },
    data2state: ({ device }) => {
        const date = device.z3k_config?.service_contact?.date;
        return {
            device_id: device.id,
            phone: device.z3k_config?.service_contact?.phone || '',
            date: parse_service_date_to_unix(date),
            usbpassword: pad0(device.z3k_config?.usbpassword || 0, 4),
            firmware_version: device.firmware_version?.[0] ?? 0,
            show_control_devices_state: device.z3k_config?.server_settings?.show_control_devices_state ?? false,
        };
    },
    validate: validate_by_specification({
        phone: minMaxStr(0, 12),
        usbpassword: all(matchesRegex(/./, 'Укажите сервисный пароль'), matchesRegex(/^\d{4}$/, 'Пароль должен состоять из 4 цифр')),
    }),
    state2data: (state) => (setter) => {
        return {
            ...setter,
            z3k_config: {
                ...setter.z3k_config,
                service_contact: {
                    phone: state.phone,
                    date: parse_service_date_to_object(state.date),
                },
                usbpassword: state.usbpassword,
                server_settings: {
                    show_control_devices_state: state.show_control_devices_state,
                },
            },
        };
    },
};
